import { Client } from '../../../../context/ClientContext';
import { MediaFile, getMediaUrl } from './mediaUtils';
import { IconButton } from '../../../ui';

interface MediaPreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedMedia: MediaFile | null;
  client?: Client;
}

export default function MediaPreviewModal({ isOpen, onClose, selectedMedia, client }: MediaPreviewModalProps) {
  if (!isOpen || !selectedMedia) return null;

  const mediaUrl = getMediaUrl(selectedMedia, client);
  const fileName = selectedMedia.object_key.split('/').pop();

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 ck-safe-pad"
      style={{ background: 'var(--surface-overlay)' }}
      onClick={onClose}
    >
      <div
        className="max-w-4xl max-h-[90dvh] w-full overflow-hidden"
        style={{
          background: 'var(--surface-card)',
          border: '1px solid var(--border-hairline)',
          borderRadius: 'var(--radius-xl)',
          boxShadow: 'var(--shadow-pop)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '12px',
            padding: '14px 18px',
            borderBottom: '1px solid var(--border-hairline)',
          }}
        >
          <div style={{ minWidth: 0 }}>
            <div className="t-eyebrow" style={{ marginBottom: '3px' }}>Preview</div>
            <div
              className="t-num"
              style={{
                fontSize: 'var(--text-sm)',
                color: 'var(--text-body)',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {fileName}
            </div>
          </div>
          <IconButton icon="x" label="Close preview" onClick={onClose} />
        </div>

        <div style={{ padding: '18px', display: 'flex', justifyContent: 'center' }}>
          {selectedMedia.mime_type?.startsWith('image/') && (
            <img
              src={mediaUrl}
              alt={selectedMedia.alt_text || fileName}
              style={{ maxWidth: '100%', maxHeight: '70dvh', objectFit: 'contain', borderRadius: 'var(--radius-md)' }}
            />
          )}

          {selectedMedia.mime_type?.startsWith('video/') && (
            <video src={mediaUrl} controls style={{ maxWidth: '100%', maxHeight: '70dvh', borderRadius: 'var(--radius-md)' }} />
          )}

          {selectedMedia.mime_type?.startsWith('audio/') && (
            <div style={{ width: '100%', maxWidth: '448px' }}>
              <audio src={mediaUrl} controls style={{ width: '100%' }} />
            </div>
          )}

          {selectedMedia.mime_type === 'application/pdf' && (
            <div style={{ width: '100%', height: '70dvh' }}>
              <iframe
                src={mediaUrl}
                style={{ width: '100%', height: '100%', borderRadius: 'var(--radius-md)', border: 'none' }}
                title={fileName}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
